import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { GuidGeneratorService } from './guid-generator.service';

@Injectable()
export class GuidGeneratorStore {

  constructor(
    private guidGeneratorService: GuidGeneratorService,
  ) { }

  generateGuid(recordType: string): Observable<string> {
    return this.guidGeneratorService.generateGuid(recordType)
      .catch(error => {
        return Observable.throw(error);
      })
      .map((res) => {
        return res.guid;
      });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/guid-generator.store.ts